import authService from './authService';
import { readData, toQuery } from './apiResponse';
import type { DashboardScope, DashboardSummary } from '../types/planning';

class DashboardService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /dashboard/summary?scope=me|team */
  async getSummary(scope: DashboardScope = 'me'): Promise<DashboardSummary> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/dashboard/summary${toQuery({ scope })}`);
    const data = await readData<DashboardSummary>(response, 'Falha ao carregar o painel');
    return {
      ...data,
      due_today_list: data?.due_today_list ?? [],
      overdue_list: data?.overdue_list ?? [],
      no_due_date_list: data?.no_due_date_list ?? [],
      upcoming_list: data?.upcoming_list ?? [],
      by_member: data?.by_member ?? [],
      boards: data?.boards ?? [],
    };
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
